import {
  OfferChoicesResultTypenames,
  OfferChoicesSuccess,
  Query,
} from '@varo/graphql-schema-types';
import { useCallback, useEffect, useState } from 'react';
import getOfferChoices from 'services/graphql/queries/rewards/GetOfferChoices';
import { CombinedError, useQuery } from 'urql';

const MAX_RETRY_ATTEMPTS = 3;

const useGetOfferChoices = () => {
  const [retryAttempt, setRetryAttempt] = useState(0);

  const [{ data, fetching: loading, error }, executeQuery] = useQuery<Query>({
    query: getOfferChoices,
    requestPolicy: 'network-only',
  });

  const retryFetchOffers = useCallback(() => {
    if (retryAttempt < MAX_RETRY_ATTEMPTS) {
      setRetryAttempt((prev) => prev + 1);
      executeQuery({ requestPolicy: 'network-only' });
    }
  }, [executeQuery, retryAttempt]);

  useEffect(() => {
    if (data && !error) {
      setRetryAttempt(0);
    }
  }, [data, error]);

  let offersData: OfferChoicesSuccess | null = null;
  let errorData: CombinedError | null = null;

  if (error) {
    errorData = error;
  } else if (data?.offerChoices) {
    if (
      data.offerChoices.__typename ===
      OfferChoicesResultTypenames.OfferChoicesSuccess
    ) {
      offersData = data.offerChoices;
    } else if (
      data.offerChoices.__typename ===
      OfferChoicesResultTypenames.OfferChoicesError
    ) {
      errorData = {
        name: data.offerChoices.title,
        message: data.offerChoices.message,
        graphQLErrors: [],
      };
    }
  }

  return {
    offersData,
    loading,
    errorData,
    retryFetchOffers,
    retryAttempt,
    maxRetryAttempts: MAX_RETRY_ATTEMPTS,
  };
};

export default useGetOfferChoices;
